import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FinancialsTab from '../../components/ApplicationPolicy/financialsTab';
import { getFinancialsForPolicy } from '../../actions/financialsTab';

// Fetches the Financials tab's Current Premium Information once per mounted applicationId - the tab's
// content component (this one) only mounts while the Financials nav item is active
// (applicationPolicyPageContent.js's activeTab switch), so re-selecting the tab re-fetches fresh data,
const FinancialsTabHOC = () => {
    const dispatch = useDispatch();
    const applicationId = useSelector((state) => state.newApplication.selectedApplication.id ? state.newApplication.selectedApplication.id : '');
    const financials = useSelector((state) => state.financialsTab.financials);
    const fetching = useSelector((state) => state.financialsTab.fetching);
    const error = useSelector((state) => state.financialsTab.error);

    useEffect(() => {
        if (applicationId) {
            dispatch(getFinancialsForPolicy(applicationId));
        }
    }, [applicationId, dispatch]);

    return (
        <FinancialsTab
            financials={financials}
            fetching={fetching}
            error={error}
        />
    );
};

export default FinancialsTabHOC;
